import { Body1, QuoteText, QuoteText2, Subtitle1 } from 'stories/elements/Typography/Text'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import theme from 'stories/utils/theme'
import useMedia from 'lib/hooks/useMedia'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
    display: grid;
    width: 60vw;
    height: auto;
    grid-template-columns: 1fr 300px;
    place-content: center center;

    @media (max-width: 750px) {
        display: flex;
        justify-content: center;
        flex-direction: column-reverse;
        width: 100vw;
        padding: 0 10%;
    }
`

export const LeftComponent = styled.div`
    position: relative;
    background-color: #fff;
    border-radius: 5px 0 0 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    color: #fff;
    padding: 50px;
    height: 500px;
    min-width: 300px;
    border-radius: ${theme.borderRadius.normal} 0 0 ${theme.borderRadius.normal};
    border: 3px solid ${theme.colors.accentBlue};
    border-right: none;
    box-shadow: 4px 4px 0px ${theme.colors.accentBlue};

    @media (max-width: 1250px) {
        padding: 25px;
    }
    @media (max-width: 750px) {
        padding-top: 20px;
        height: auto;
        min-height: 300px;
        border-radius: 0 0 ${theme.borderRadius.normal} ${theme.borderRadius.normal};
        box-shadow: 4px 0px 0px ${theme.colors.accentBlue};
        border: 3px solid ${theme.colors.accentBlue};
        border-top: none;
        min-width: 100%;
    }
`

export const QuotationWrapper = styled.div`
    margin-top: 25px;
    @media (max-width: 750px) {
        margin-top: 0;
    }
`

export const FooterInfo = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    vertical-align: left;
    top: 50px;
    left: 50px;
    z-index: 1;
    @media (max-width: 750px) {
        top: 15px;
        left: 0;
        right: 0;
        margin: 0 auto;
        * {
            text-align: center;
        }
    }
`

export const RightComponent = styled.div`
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border: 3px solid ${theme.colors.accentBlue};
    border-left: none;
    border-radius: 0 ${theme.borderRadius.large} ${theme.borderRadius.large} 0;
    box-shadow: 4px 4px 0px ${theme.colors.accentBlue};
    position: relative;
    height: 500px;
    width: 300px;
    @media (max-width: 750px) {
        width: 100%;
        min-height: 250px !important;
        border-radius: ${theme.borderRadius.card} ${theme.borderRadius.card} 0 0;
        border: 3px solid ${theme.colors.accentBlue};
        border-bottom: none;
        box-shadow: 4px 0px 0px ${theme.colors.accentBlue};
        flex: 2;
    }
`

interface Props {
    text: string
    image?: StaticImageData | string
    imageWebp?: StaticImageData | string
    footerInfo?: {
        title: string
        subtitle: string
    }
}

const TestimonialCard = (props: Props) => {
    const md = useMedia(deviceSize.md)
    return (
        <Container>
            <LeftComponent>
                <QuotationWrapper>
                    {props.footerInfo ? (
                        <>
                            <FooterInfo>
                                <Subtitle1 color={theme.colors.darkerAccentBlue}>{props.footerInfo.title}</Subtitle1>
                                <Body1 color={theme.colors.headlineDark}>{props.footerInfo.subtitle}</Body1>
                            </FooterInfo>
                        </>
                    ) : null}
                    {md ? <QuoteText2>{props.text}</QuoteText2> : <QuoteText>{props.text}</QuoteText>}
                </QuotationWrapper>
            </LeftComponent>
            {props.imageWebp ? (
                <RightComponent
                    style={{
                        backgroundImage: `url(${
                            typeof props.imageWebp === 'string' ? props.imageWebp : props.imageWebp.src
                        })`,
                    }}
                />
            ) : null}
        </Container>
    )
}

export default TestimonialCard
